import { Controller } from "@hotwired/stimulus";
import { addToQueue } from "../../pwa/offline_queue";
import { showPwaFlash } from "../../pwa/show_pwa_flash";

export default class extends Controller {
    async submit(event) {
        const form = this.element

        document
            .querySelectorAll(".member-checkbox")
            .forEach(cb => cb.setAttribute("form", form.id))

        if (navigator.onLine) return

        event.preventDefault()

        const formData = new FormData(form)

        const payload = {}

        // Track file inputs for photo preview rendering
        const fileInputs = []

        for (let [key, value] of formData.entries()) {

            if (value instanceof File && value.size > 0) {
                payload[key] ||= []
                payload[key].push(await this.fileToBase64(value))

                // Collect file input info for preview
                const input = document.querySelector(`input[type="file"][name="${key}"]`) ||
                    document.querySelector(`input[name="${CSS.escape(key)}"]`);
                if (input && !fileInputs.includes(input)) {
                    fileInputs.push(input)
                }

                continue
            }

            if (payload[key]) {
                if (!Array.isArray(payload[key])) {
                    payload[key] = [payload[key]]
                }
                payload[key].push(value)
            } else {
                payload[key] = value
            }
        }
        // Capture the actual clock-in/out timestamp
        payload["offline_timestamp"] = new Date().toISOString()

        const type = form.action.includes("clock_out") ? "clock_out" : "clock_in"

        await addToQueue({
            type,
            payload
        })

        // Render photo previews for selected files
        this.renderOfflinePhotoPreviews(fileInputs)

        showPwaFlash("現在、あなたはオフラインです。オンラインに戻った時点で出席が記録されます。", "error")
    }

    renderOfflinePhotoPreviews(fileInputs) {
        for (const input of fileInputs) {
            const previewContainer = input.closest("div")?.querySelector("[data-photo-preview]")
            if (!previewContainer) continue

            const files = input.files
            if (!files || files.length === 0) continue

            // Clear any existing previews
            previewContainer.innerHTML = ""

            const heading = document.createElement("strong")
            heading.textContent = "選択したファイル:"
            previewContainer.appendChild(heading)

            for (const file of files) {
                if (!file.type.startsWith("image/")) continue

                const reader = new FileReader()
                reader.onload = (e) => {
                    const wrapper = document.createElement("div")
                    wrapper.className = "photo-preview"

                    const img = document.createElement("img")
                    img.src = e.target.result
                    img.style.maxWidth = "120px"
                    img.style.maxHeight = "120px"

                    const name = document.createElement("p")
                    name.textContent = file.name

                    wrapper.appendChild(img)
                    wrapper.appendChild(name)
                    previewContainer.appendChild(wrapper)
                }
                reader.readAsDataURL(file)
            }
        }
    }

    fileToBase64(file) {
        return new Promise((resolve) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result);
            reader.readAsDataURL(file)
        })
    }
}